import React, {useEffect} from 'react'
import {useForm, FormProvider} from "react-hook-form";
import Form from "../components/Form/Form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import UiInputSuggest from "../components/Form/UiInputSuggest";
import UiInputList from "../components/Form/UiInputList";
import UiInputText from "../components/Form/UiInputText";
import UiInputMoney from "../components/Form/UiInputMoney";
import UiInputTextarea from "../components/Form/UiInputTextarea";

const tipoList = [
    { id: 'entrada', title: 'Entrada' },
    { id: 'saida', title: 'Saída' },
    { id: 'ajuste', title: 'Ajuste' },
];

const produtoFilter = [
    { name: 'tipo', operator: 'eq', value: 'produto' },
];

export default function EstoqueMovimentoForm(props: any){
    const methods = useForm({
        defaultValues: props.data
    });
    const { handleSubmit, reset } = methods;

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                <WindowBody>
                    <div className="row">
                        <UiInputSuggest size={12} name="produto" router="produto" idField="id" titleField="nome" label="Produto" initialFilter={produtoFilter}/>
                        <UiInputSuggest size={6} name="deposito" router="deposito" idField="id" titleField="nome" label="Depósito"/>
                        <UiInputList size={6} name="tipo" list={tipoList} idField="id" titleField="title" label="Tipo"/>
                        <UiInputText size={6} name="quantidade" label="Quantidade" type="number" step="0.001" min="0"/>
                        <UiInputMoney size={6} name="custoUnitario" label="Custo Unitário"/>
                        <UiInputTextarea size={12} name="observacao" label="Observação" rows={3}/>
                    </div>
                    <p className="text-muted small mb-0">Movimentos são imutáveis: correções devem ser feitas com um novo lançamento.</p>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Salvar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    )
}
